module.exports = __webpack_public_path__ + "/bundle/asset/admission2-1-8f969ea38277b49a336fb96392fc057c.png";